export default "__VITE_ASSET__Co66FzK4__"